import { Link } from "react-router-dom";
import { useContext } from "react";
import { LangContext } from "../../contexts/Language";
import "./NotFound.Module.css";

const content = {
    BG: {
        heading: "Страницата не е намерена",
        text: "Страницата, която търсите, не съществува.",
        btn: "Към началната страница",
    },
    EN: {
        heading: "Page Not Found",
        text: "The page you are looking for does not exist.",
        btn: "Back to Home",
    },
    RU: {
        heading: "Страница не найдена",
        text: "Страница, которую вы ищете, не существует.",
        btn: "На главную",
    },
    CZ: {
        heading: "Stránka nenalezena",
        text: "Stránka, kterou hledáte, neexistuje.",
        btn: "Na hlavní stránku",
    },
};

export const NotFound = () => {
    const { lang } = useContext(LangContext);
    const t = content[lang] || content.BG;

    return (
        <section className="not-found">
            <h1>404</h1>
            <h2>{t.heading}</h2>
            <p>{t.text}</p>
            <Link to="/" className="not-found-btn">{t.btn}</Link>
        </section>
    );
};
